import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import { Calendar } from 'primereact/calendar';
import { InputMask } from 'primereact/inputmask';
import moment from "moment";

const CandidateWorkexperienceFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    const values = {...data, ...formData, ...newFormData};
    const dates = Object.fromEntries(['start_date', 'end_date'].map(key => [key, values[key] ? moment(values[key]).format('YYYY-MM-DD') : null]));
    if ((window.App.urlVars().candidateWorkexperienceId) || (entity === 'candidate-workexperience' && id)) {
      const payload = {
        ...formData,
        ...newFormData,
        ...dates,
        candidate: id,
      }
      apiCall('patch', '/api/v2/candidate-work-experience/' + (window.App.urlVars().candidateWorkexperienceId ?? id), payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderCandidateWorkexperienceList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      const payload = {
        ...values,
        ...dates,
        candidate: id,
      }
      apiCall('post', '/api/v2/candidate-work-experience', payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderCandidateWorkexperienceList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push(`/recruitment/candidate/read/${id}/candidate-work-experience/candidate-work-experience/update/` + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    if ((!window.App.urlVars().create && window.App.urlVars().candidateWorkexperienceId) || (entity === 'candidate-workexperience' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/candidate-work-experience/' + (window.App.urlVars().candidateWorkexperienceId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])


  return (
    <div className={"candidate-workexperience-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>

            <div className={"p-col-12 p-lg-6"}>
              <Field name="company_name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="company_name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCompanyName')}</label>
                  <span className="p-d-block">
                      <InputText id="company_name" {...input}
                                // options={company}
                                // optionValue='id'
                                // optionLabel='name'
                                 onChange={(e) => {
                                  // input.onChange(e.value)
                                   setFormData({
                                     ...formData,
                                     company_name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     company_name: e.target.value
                                   })
                                 }}
                                 value={input.value}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


            <div className={"p-col-12 p-lg-6"}>
              <Field name="job" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="job"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldJob')}</label>
                  <span className="p-d-block">
                      <InputText id="job" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     job: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     job: e.target.value
                                   })
                                 }}
                                 value={formData.job}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


            <div className={"p-col-12 p-lg-6"}>
              <Field name="start_date" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="start_date"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldEmploymentStartDate')}</label>
                  <div className="p-inputgroup calendar-icon-only">
                    <InputMask id={"start_date"}
                                mask={"9999-99-99"}
                                placeholder={t('datePlaceholder')}
                                value={formData.start_date ? moment(formData.start_date).format('YYYY-MM-DD') : ''}
                                onChange={(e) => {
                                  if (e.value.indexOf("_") === -1) {
                                    if (e.value === '') {
                                      e.value = null
                                    }
                                    setFormData({
                                      ...formData,
                                      start_date: e.value || null
                                    })
                                    setNewFormData({
                                      ...newFormData,
                                      start_date: e.value || null
                                    })
                                  }
                                }}
                      />
                      <Calendar value={formData.start_date ? moment(formData.start_date).toDate() : null}
                                mask={"9999-99-99"}
                                placeholder={t('datePlaceholder')}
                                locale="hu" 
                                showIcon
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     start_date: e.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     start_date: e.value
                                   })
                                 }}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </div>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="end_date" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="end_date"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldEmploymentEndDate')}</label>
                    <div className="p-inputgroup calendar-icon-only">
                      <InputMask
                        id={"end_date"}
                        mask={"9999-99-99"}
                        placeholder={t('datePlaceholder')}
                        value={formData.end_date ? moment(formData.end_date).format('YYYY-MM-DD') : ''}
                        onChange={(e) => {
                          if (e.value.indexOf("_") === -1) {
                            const value = e.value === '' ? null : e.value;

                            setFormData({
                              ...formData,
                              end_date: value
                            });

                            setNewFormData({
                              ...newFormData,
                              end_date: value
                            });
                          }
                        }}
                      />

                      <Calendar
                        value={formData.end_date ? moment(formData.end_date).toDate() : null}
                        mask={"9999-99-99"}
                        placeholder={t('datePlaceholder')}
                        locale="hu"
                        showIcon
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            end_date: e.value || null
                          });

                          setNewFormData({
                            ...newFormData,
                            end_date: e.value || null
                          });
                        }}
                        className={classNames({'p-invalid': isFormFieldValid(meta)})}
                      />
                    </div>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'candidate-workexperience' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(CandidateWorkexperienceFormComponent);
